import { useLocation } from "wouter";
import { 
  Home, 
  GraduationCap, 
  ClipboardCheck, 
  TrendingUp, 
  MessageSquare, 
  Users,
  BarChart3,
  Settings,
  UserPlus,
  MapPin,
  HelpCircle,
  Bot,
  Slack,
  FolderOpen
} from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface SidebarProps {
  userRole: string;
}

export default function Sidebar({ userRole }: SidebarProps) {
  const [location, setLocation] = useLocation();

  const getNavigationItems = () => {
    const commonItems = [
      { href: "/", icon: Home, label: "Dashboard" },
    ];

    switch (userRole) {
      case 'admin':
        return [
          ...commonItems,
          { href: "/training", icon: GraduationCap, label: "Knowledge Hub" },
          { href: "/analytics", icon: BarChart3, label: "Analytics" },
          { href: "/users", icon: Users, label: "Manage Employees" },
          { href: "/team-images", icon: FolderOpen, label: "Team Media" },
          { href: "/slack-integration", icon: Slack, label: "Slack Integration" },
          { href: "/feedback", icon: MessageSquare, label: "View Feedback" },
          { href: "/ai-agent", icon: Bot, label: "AI Agent" },
        ];
      case 'candidate':
        return [
          { href: "/", icon: Home, label: "Dashboard" },
        ];
      default: // employee
        return [
          ...commonItems,
          { href: "/knowledge-hub", icon: GraduationCap, label: "Knowledge Hub" },
          { href: "/meet-buddy", icon: UserPlus, label: "Meet Your Buddy" },
          // Temporarily hidden - will be used later
          // { href: "/meet-the-team", icon: Users, label: "Meet The Team" },
          // { href: "/office-locations", icon: MapPin, label: "Office Location" },
          { href: "/helpdesk", icon: HelpCircle, label: "Servify Helpdesk" },
          { href: "/progress", icon: TrendingUp, label: "Your Progress" },
          { href: "/feedback", icon: MessageSquare, label: "Feedback" },
        ];
    }
  };

  const navigationItems = getNavigationItems();

  const handleRoleSwitch = (newRole: string) => {
    // This would typically involve an API call to switch roles or redirect
    // For now, we'll just show the selection
    console.log("Switching to role:", newRole);
  };

  return (
    <aside className="w-64 bg-white min-h-screen border-r border-gray-200" data-testid="sidebar">
      <div className="p-6">

        {/* Navigation Menu */}
        <nav className="space-y-2" data-testid="sidebar-navigation">
          {navigationItems.map((item) => {
            const isActive = location === item.href;
            return (
              <Button
                key={item.href}
                variant="ghost"
                className={cn(
                  "w-full justify-start text-left",
                  isActive 
                    ? "text-servify-purple bg-servify-purple/10 hover:bg-servify-purple/10"
                    : "text-gray-600 hover:text-servify-purple hover:bg-gray-50"
                )}
                onClick={() => setLocation(item.href)}
                data-testid={`link-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <item.icon className="mr-3 h-5 w-5" />
                {item.label}
              </Button>
            );
          })}
        </nav>
      </div>
    </aside>
  );
}
